// External dependencies
import React, { PureComponent } from 'react';

// Custom components
import MessageCard from '../../components/Cards/MessageCard.js';
import Modal from '../../components/Modals/Modal.js';
import Text from '../../components/Text.js';
import TextInput from '../../components/TextFields/TextInput.js';
import ClassBlock from './ClassBlock.js';

// Services
import * as Services from '../../services/index.js';

// Utility functions
import { helpers } from '@simplybenefits/sb-utils';

// Localization
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class AssignPlans extends PureComponent {
  state = {
    classIDs: helpers.sortObjByTitle(this.props.classData),
    assignedPlans: {},
    rejectionReason: '',
    showRejectionDialog: false,
    showPlanAssignmentDialog: false,
    loading: true
  };

  // eslint-disable-next-line require-await
  async componentDidMount() {
    const assignedPlans = {};

    // eslint-disable-next-line array-callback-return
    this.state.classIDs.map(classID => {
      const classDesigns = this.props.designs[classID];
      const designIDs = Object.keys(classDesigns);
      assignedPlans[classID] = designIDs[0];
    });
    this.setState({
      assignedPlans,
      loading: false
    });
  }
  _assignPlan = (classID, designID) => {
    this.setState({
      assignedPlans: {
        ...this.state.assignedPlans,
        [classID]: designID
      }
    });
  };
  _toggleRejectionDialog = () => {
    this.setState({
      showRejectionDialog: !this.state.showRejectionDialog
    });
  };
  _togglePlanAssignmentDialog = () => {
    this.setState({
      showPlanAssignmentDialog: !this.state.showPlanAssignmentDialog
    });
  };
  _rejectPricing = async () => {
    const rejectionReasonError = await Services.validateInput('checkEmpty', this.state.rejectionReason);
    if (rejectionReasonError) {
      this.setState({
        rejectionReasonError: i18n.t(tokens.labels.quotes.reasonForRejectingPlans)
      });
      return null;
    }
    const success = await this.props.rejectPricing(this.props.currentAccountMeta.accountID, this.state.rejectionReason);
    if (success) {
      this._toggleRejectionDialog();
    }
    return true;
  };
  _submit = async () => {
    this._togglePlanAssignmentDialog();
    const success = await this.props.assignPlans(this.props.currentAccountMeta.accountID, this.state.assignedPlans);
    if (success) {
      this.props.setSelectedSection(null);
    }
  };
  _handleChange = value => {
    this.setState({
      rejectionReason: value
    });
  };
  render() {
    if (this.state.loading || this.state.assignedPlans === {}) {
      return null;
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.isRevision ? /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.planDesignAssignment),
      subtitle: i18n.t(tokens.labels.planDesign.pleaseSelectPlanDesign),
      btn: true,
      btnName: i18n.t(tokens.buttons.submit),
      btnOnClick: this._togglePlanAssignmentDialog
    }) : /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.titles.planDesignAssignment),
      subtitle: i18n.t(tokens.labels.planDesign.pleaseSelectPlanDesignRejectionWording),
      btn: true,
      btnName: i18n.t(tokens.buttons.submit),
      btnOnClick: this._togglePlanAssignmentDialog,
      btn2: true,
      btnName2: i18n.t(tokens.buttons.rejectPricing),
      btnOnClick2: this._toggleRejectionDialog
    }), this.state.classIDs.map((classID, i) => {
      const data = this.props.classData[classID];

      // if it's modular flex then we don't want to show the parent classes, only the flex classes
      if (data.isModular && data.parentClassID === null) {
        return null;
      }
      const title = `${i18n.t(tokens.titles.class)}: ${data.title}`;
      return /*#__PURE__*/React.createElement(ClassBlock, {
        title: title,
        classID: classID,
        classData: this.props.classData,
        assignedPlans: this.state.assignedPlans,
        designs: this.props.designs,
        onSelect: this._assignPlan,
        whitelabel: this.props.whitelabel,
        key: i
      });
    }), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showRejectionDialog,
      onClose: this._toggleRejectionDialog,
      title: i18n.t(tokens.titles.pricingRejection),
      primaryButton: {
        label: i18n.t(tokens.buttons.continue),
        onClick: this._rejectPricing
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.planDesign.clickContinueSalesNotification)), /*#__PURE__*/React.createElement(TextInput, {
      label: i18n.t(tokens.labels.planDesign.rejectionReason),
      fullWidth: true,
      multiline: true,
      rows: 8,
      value: this.state.rejectionReason,
      onChange: e => this._handleChange(e.target.value),
      variant: "outlined",
      error: Boolean(this.state.rejectionReasonError),
      helperText: this.state.rejectionReasonError
    })), /*#__PURE__*/React.createElement(Modal, {
      open: this.state.showPlanAssignmentDialog,
      onClose: this._togglePlanAssignmentDialog,
      title: i18n.t(tokens.titles.areYouSure),
      primaryButton: {
        label: i18n.t(tokens.buttons.continue),
        onClick: this._submit
      },
      loader: this.props.loader
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.planDesign.clickContinuePlanAssignment))));
  }
}
export default AssignPlans;